import {combineReducers} from "@reduxjs/toolkit"
import showMenuSlice from "./slices/showMenuSlice";


const rootReducer = combineReducers({
  showMenu : showMenuSlice , 
  
})

export default rootReducer;